import { useTranslation } from 'react-i18next';
import {
    ArrowCounterClockwiseIcon,
    ArrowSquareOutIcon,
    TrashIcon,
} from '@phosphor-icons/react';

import { I18nNamespace } from '@/lib/i18n-namespaces';
import { CameraTableRow } from '../types';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/Tooltip';
import { Button } from '@/components/ui/Button';

interface CameraActionsCellProps {
    camera: CameraTableRow;
    onDelete: (camera: CameraTableRow) => void;
    onRefresh: (sourceId: string) => void;
}

export function CameraActionsCell({
    camera,
    onDelete,
    onRefresh,
}: CameraActionsCellProps) {
    const { t } = useTranslation(I18nNamespace.CAMERAS);

    return (
        <div
            className="flex items-center justify-center gap-3"
            onClick={(e) => e.stopPropagation()}
        >
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        shape="square"
                        aria-label={t('actions.refreshTitle')}
                        onClick={() => onRefresh(camera.sourceId)}
                    >
                        <ArrowCounterClockwiseIcon size={16} weight="regular" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="top">
                    {t('actions.refreshTitle')}
                </TooltipContent>
            </Tooltip>

            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        shape="square"
                        aria-label={t('actions.openSource')}
                        onClick={() => {
                            window.open(
                                `/sources/${camera.sourceId}`,
                                '_blank',
                                'noopener,noreferrer',
                            );
                        }}
                    >
                        <ArrowSquareOutIcon size={16} weight="regular" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="top">
                    {t('actions.openSource')}
                </TooltipContent>
            </Tooltip>

            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        shape="square"
                        aria-label={t('actions.deleteTitle')}
                        onClick={() => onDelete(camera)}
                        className="text-danger-200 hover:bg-danger-200/10"
                    >
                        <TrashIcon size={16} weight="regular" />
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="top">
                    {t('actions.deleteTitle')}
                </TooltipContent>
            </Tooltip>
        </div>
    );
}
